module.exports = __webpack_public_path__ + "static/OP4-76fe74212eff24f801f63d02ac6034ff.png";